import Vue from 'vue'
import Vuetify, {
    VBottomSheet, // needed due to workaround for v-bottom-sheet scroll-behind
} from 'vuetify/lib'

Vue.use(Vuetify, {
    components: {
        VBottomSheet, // ...workaround...
    },
    directives: {
    },
})

const opts = {}

export default new Vuetify(opts)
